import { DeviceNotificationType, SensorReadingType, DeviceNotificationInfo, DeviceNotification, DeviceInfo, Device, WaterScheduleInfo, WaterSchedule, DeviceCamera, DeviceCameraInfo } from "@models";
import { TimerRound } from "@models/Irrigation/timerRound";
import moment from "moment";

export class DeviceMapping {
  
  constructor() {}


  getDeviceNotificationTypeStringForDeviceNotificationType(deviceNotifictionType: DeviceNotificationType): string {
    switch (deviceNotifictionType.toString()) {
    case '0':
      return 'NoDeviceResponse';
    case '1':
      return 'NoSensorResponse';
    case '2':
      return 'ValueResponse';
    default:
      return '';
    }
  }


  getDeviceNotificationTypeForDeviceNotificationTypeString(deviceNotifictionTypeString: string): DeviceNotificationType {
    switch (deviceNotifictionTypeString) {
    case 'NoDeviceResponse':
      return DeviceNotificationType.NoDeviceResponse;
    case 'NoSensorResponse':
      return DeviceNotificationType.NoSensorResponse;
    case 'ValueResponse':
      return DeviceNotificationType.ValueResponse;
    default:
      return DeviceNotificationType.NoDeviceResponse;
    }
  }


  getReadingTypeFromID(dataTypeID: number, sensorReadingTypes: SensorReadingType[]): SensorReadingType {
    const dataType: SensorReadingType = sensorReadingTypes.find(d => d.id == dataTypeID);
    if (dataType != null) {
      return { id: dataType.id, type: dataType.type };
    }
    return { id: 6, type: 'moisture'};
  }


  mapDeviceNotificationInfos2DeviceNotifications(deviceNotificationInfos: DeviceNotificationInfo[], sensorReadingTypes: SensorReadingType[]): DeviceNotification[] {
    const deviceNotifications: DeviceNotification[] = [];

    deviceNotificationInfos.forEach(dNotifyInfo => {
      const dNotify: DeviceNotification = {
        id: dNotifyInfo.id,
        timeSpan: dNotifyInfo.timeSpan,
        isEnabled: dNotifyInfo.isEnabled,
        missedCount: dNotifyInfo.missedCount,
        sensorValue: dNotifyInfo.sensorValue,
        sensorDataType: this.getReadingTypeFromID(dNotifyInfo.dataTypeID, sensorReadingTypes),
        type: dNotifyInfo.type.toString()
      };
      deviceNotifications.push(dNotify);
    });

    return deviceNotifications;
  }


  mapDeviceNotifications2DeviceNotificationInfos(deviceNotifications: DeviceNotification[]): DeviceNotificationInfo[] {
    const deviceNotificationInfos: DeviceNotificationInfo[] = [];

    deviceNotifications.forEach(dNotify => {
      const dNotifyInfo: DeviceNotificationInfo = {
        id: dNotify.id,
        timeSpan: dNotify.timeSpan,
        isEnabled: dNotify.isEnabled,
        missedCount: dNotify.missedCount,
        sensorValue: dNotify.sensorValue,
        dataTypeID: dNotify.sensorDataType.id,
        type: this.getDeviceNotificationTypeForDeviceNotificationTypeString(dNotify.type)
      };
      deviceNotificationInfos.push(dNotifyInfo);
    });

    return deviceNotificationInfos;
  }


  mapDeviceInfo2Device(deviceInfo: DeviceInfo, sensorReadingTypes: SensorReadingType[]): Device {
    const device: Device = {
      id: deviceInfo.id,
      name: deviceInfo.name,
      description: deviceInfo.description,
      //type: this.getDeviceTypeStringForDeviceType(deviceInfo.type),
      mode: deviceInfo.mode,
      registerDate: moment.utc(deviceInfo.registerDate).toDate(),
      serialNumber: deviceInfo.serialNumber,
      macAddress: deviceInfo.macAddress,
      ipAddress: deviceInfo.ipAddress,
      netmask: deviceInfo.netmask,
      networkInterface: deviceInfo.networkInterface,
      gpsLocation: deviceInfo.gpsLocation,
      sensorUUIDs: deviceInfo.sensorUUIDs,
      //sensors: deviceInfo.sensors,
      waterSchedules: this.mapWaterScheduleInfos2WaterSchedules(deviceInfo.deviceWaterScheduleInfos),
      notificationDestination: deviceInfo.notificationDestination,
      deviceNotifications: this.mapDeviceNotificationInfos2DeviceNotifications(deviceInfo.deviceNotifications, sensorReadingTypes),
      userName: deviceInfo.userName,
      userGroup: deviceInfo.userGroup,
      userGroupId: deviceInfo.userGroupId,
      aliveTimeStamp: null,
      aliveColor: 'clear',
      connectivity: [],
      ingestStats: [],
      isDisabled: deviceInfo.isDisabled,
      apiKey: '',
      mountAngle: deviceInfo.mountAngle,
      deviceCameras: this.mapDeviceCameraInfo2DeviceCamera(deviceInfo.deviceCameras),
      deviceFunctionIds: deviceInfo.deviceFunctionIds ?? [],
      waterRate: deviceInfo.waterRate
    };

    return device;
  }


  mapDevice2DeviceInfo(device: Device): DeviceInfo {
    const deviceInfo: DeviceInfo = {
      id: device.id,
      name: device.name,
      description: device.description,
      //type: this.getDeviceTypeForDeviceTypeString(device.type),
      mode: device.mode,
      registerDate: device.registerDate,
      serialNumber: device.serialNumber,
      macAddress: device.macAddress,
      ipAddress: device.ipAddress,
      netmask: device.netmask,
      networkInterface: device.networkInterface,
      gpsLocation: device.gpsLocation,
      sensorUUIDs: device.sensorUUIDs,
      deviceWaterScheduleInfos : this.mapWaterSchedules2WaterScheduleInfos(device.waterSchedules),
      notificationDestination: device.notificationDestination,
      deviceNotifications: this.mapDeviceNotifications2DeviceNotificationInfos(device.deviceNotifications),
      userName: device.userName,
      userGroup: device.userGroup,
      userGroupId: device.userGroupId,
      isDisabled: device.isDisabled,
      mountAngle: device.mountAngle,
      deviceCameras: this.mapDeviceCamera2DeviceCameraInfo(device.deviceCameras),
      deviceFunctionIds: device.deviceFunctionIds ?? [],
      waterRate: device.waterRate
    };

    return deviceInfo;
  }


  mapDeviceInfos2Devices(deviceInfos: DeviceInfo[], sensorReadingTypes: SensorReadingType[]): Device[] {
    const devices: Device[] = [];

    deviceInfos.forEach( dInfo => {
      devices.push(this.mapDeviceInfo2Device(dInfo, sensorReadingTypes));
    });

    return devices;
  }


  mapDevices2DeviceInfos(devices: Device[]): DeviceInfo[] {
    const deviceInfos: DeviceInfo[] = [];

    devices.forEach( d => {
      deviceInfos.push(this.mapDevice2DeviceInfo(d));
    });

    return deviceInfos;
  }


  mapDeviceCameraInfo2DeviceCamera(cameraInfos: DeviceCameraInfo[]): DeviceCamera[] {
    var cameras: DeviceCamera[] = [];

    cameraInfos.forEach(x => {
      var camera: DeviceCamera = {
        id: x.id,
        deviceId: x.deviceId,
        name: x.name,
        type: x.type,
        model: x.model,
        port: x.port,
        login: x.login,
        presets: x.presets,
        power: (x.settings != undefined && x.settings["power"] != undefined) ? x.settings["power"] : ""
      };
      cameras.push(camera);
    });

    return cameras;
  }


  mapDeviceCamera2DeviceCameraInfo(cameras: DeviceCamera[]): DeviceCameraInfo[] {
    var cameraInfos: DeviceCameraInfo[] = [];

    cameras.forEach(x => {
      var cameraInfo: DeviceCameraInfo = {
        id: x.id,
        deviceId: x.deviceId,
        name: x.name,
        type: x.type,
        model: x.model,
        port: x.port,
        login: x.login,
        presets: x.presets,
        settings: { "power": x.power }
      };
      cameraInfos.push(cameraInfo);
    });
    
    return cameraInfos;
  }


  mapWaterScheduleInfos2WaterSchedules(waterScheduleInfos: WaterScheduleInfo[]): WaterSchedule[] {
    const waterSchedules: WaterSchedule[] = [];

    if (waterScheduleInfos == null) {
      return waterSchedules;
    }

    waterScheduleInfos.forEach( wsInfo => {
      let timerRounds: TimerRound[] = [];

      if (wsInfo.timerRounds != null) {
        timerRounds = JSON.parse(wsInfo.timerRounds);
      }

      const waterSchedule: WaterSchedule = {
        id: wsInfo.id,
        name: wsInfo.name,
        isEnabled: wsInfo.isEnabled,
        isSelfOwned: wsInfo.isSelfOwned,
        cycles: 0,
        timeOff: 0,
        timeOn: 0,
        timerRounds,
        usedByCount: 0,
        usedByTrigger: [],
        ownerID: -1,
        ownerName: '',
        ownerChanged: false
      };

      this.calculateWaterScheduleCycleOnOffValues(waterSchedule);
      waterSchedules.push(waterSchedule);
    });

    return waterSchedules;
  }


  mapWaterSchedules2WaterScheduleInfos(waterSchedules: WaterSchedule[]): WaterScheduleInfo[] {
    const waterScheduleInfos: WaterScheduleInfo[] = [];

    if (waterSchedules == null) {
      return waterScheduleInfos;
    }

    waterSchedules.forEach( wss => {
      const waterScheduleInfo: WaterScheduleInfo = {
        id: wss.id,
        name: wss.name,
        isEnabled: wss.isEnabled,
        isSelfOwned: wss.isSelfOwned,
        cycles: wss.cycles,
        timerRounds: JSON.stringify(wss.timerRounds)
      };
      waterScheduleInfos.push(waterScheduleInfo);
    });

    return waterScheduleInfos;
  }


  calculateWaterScheduleCycleOnOffValues(waterSchedule: WaterSchedule) {
    waterSchedule.cycles = 0;
    waterSchedule.timeOn = 0;
    waterSchedule.timeOff = 0;

    waterSchedule.timerRounds.forEach((x)=>{
      waterSchedule.timeOn += x.on * x.multiplier;
      waterSchedule.timeOff += x.off * x.multiplier;
      waterSchedule.cycles += x.multiplier;
    });
  }

}
